//#region src/utils/bit.ts
function bHas(bit, value) {
	return (bit & value) === value;
}
//#endregion
export { bHas };
